import { LAYOUT } from "../../constants/constants";

export const getLayoutDetail = () => async (dispatch) => {
  const urls = ["./educationJson.json", "./projectsfile.json", "./workEx.json"];

  const fetchApi = (url) =>
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then((a) => a.json());

  Promise.all(urls.map(fetchApi)).then(([education, projects, workEx]) => {
    dispatch({
      type: LAYOUT.SET_INITIAL_DETAILS,
      payload: { ...education, ...projects, ...workEx },
    });
  });
};

export const updateReduxKey = (obj = {}) => (dispatch) => {
  dispatch({
    type: LAYOUT.SET_REDUX_KEY,
    payload: obj,
  });
};

export const setDefaultState = () => (dispatch) => {
  dispatch({
    type: LAYOUT.SET_DEFAULT_STATE,
  });
};

export const setTemplate = (template) => (dispatch) => {
  dispatch({
    type: LAYOUT.SET_TEMPLATE,
    payload: template,
  });
};

export const setViewType = (viewTypeObj) => (dispatch) => {
  dispatch({
    type: LAYOUT.SET_VIEW_TYPE,
    payload: viewTypeObj,
  });
};

export const setAdditionalSections = (additionalSection) => (dispatch) => {
  dispatch({
    type: LAYOUT.SET_ADDITIONAL_FIELDS,
    payload: additionalSection,
  });
};

export const updateAdditionalSections = (additionalSections) => (dispatch) => {
  dispatch({
    type: LAYOUT.UPDATE_ADDITIONAL_FIELDS,
    payload: additionalSections,
  });
};

export const setImportedDataFromFile = (fileResponse) => (dispatch) => {
  dispatch({
    type: LAYOUT.SET_RESUME_FROM_FILE,
    payload: fileResponse,
  });
};
